import styled from 'styled-components';

export const Heading = styled.h4`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 800;
    font-size: 44px;
    line-height: 54px;
    margin-bottom: 20px;
    @media screen and (max-width: 1200px) {
        font-size: 34px;
        line-height: 41px;
    }
    @media screen and (max-width: 800px) {
        font-size: 24px;
        line-height: 27px;
        margin-bottom: 20px;
    }
    span {
        color: #00aff0;
    }
`;
export const WrapText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;
export const Description = styled.p`
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 40px;
    @media screen and (max-width: 800px) {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 30px;
    }
`;
export const Text = styled(Description)`
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 5px;
    @media screen and (max-width: 800px) {
        margin-bottom: 5px;
    }
`;

export const BaseTextStyle = styled.div`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 140%;
    color: #404040;

    a {
        color: #0b9cdb;

        &:hover {
            text-decoration: underline;
        }
    }

    @media screen and (max-width: 760px) {
        font-size: 18px;
        line-height: 150%;
    }
`;

export const BaseListStyles = styled.ul`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 140%;
    color: #404040;
    padding: 0 20px;
    box-sizing: border-box;

    li {
        margin-top: 0;
        margin-bottom: 0;
    }

    @media screen and (max-width: 760px) {
        font-size: 18px;
        line-height: 150%;
    }
`;
